import "bootstrap/js/dist/modal"

class NewsletterOverlay {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("NewsletterOverlay::initialize()")

		const overlay = document.querySelector(".bb-newsletter-overlay")

		overlay.querySelector(".bb-show-example-button").addEventListener("click", () => this._showExample(overlay))
		overlay.querySelector(".bb-show-faq-button").addEventListener("click", () => this._showFAQ(overlay))
		overlay.addEventListener("show.bs.modal", (event) => {
			const button = event.relatedTarget
			const type = button.dataset.type

			if (type === "faq") {
				this._showFAQ(overlay)
			} else {
				this._showExample(overlay)
			}
		})
	}
	_showFAQ(overlay) {
		overlay.querySelector(".bb-newsletter-overlay--faq").classList.add("active")
		overlay.querySelector(".bb-newsletter-overlay--example").classList.remove("active")
		overlay.querySelector(".bb-show-faq-button").classList.add("active")
		overlay.querySelector(".bb-show-example-button").classList.remove("active")
	}

	_showExample(overlay) {
		overlay.querySelector(".bb-newsletter-overlay--example").classList.add("active")
		overlay.querySelector(".bb-newsletter-overlay--faq").classList.remove("active")
		overlay.querySelector(".bb-show-example-button").classList.add("active")
		overlay.querySelector(".bb-show-faq-button").classList.remove("active")
	}
}

export default NewsletterOverlay
